import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a30d0066"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toolbar no-header" }, null, -1))
const _hoisted_2 = { class: "content ion-padding" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "blocks"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "ion-padding" }
const _hoisted_8 = { class: "title shadow" }
const _hoisted_9 = { class: "title fashion" }

import { useRoute } from 'vue-router'
import { computed, onMounted, ref } from 'vue'
import { renderRichText, useStoryblok } from '@storyblok/vue'
import { IonPage } from '@ionic/vue'
import { useDebounceFn, useWindowSize } from '@vueuse/core'
import { useMeta } from 'vue-meta'

import Page from '@/models/Page'
import ExpandTransition from '@/components/ExpandTransition.vue'
import { useStore } from '@/store'
import { useContent } from '@/composables/content'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageDetail',
  props: {
    slug: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
  slug?: string
  data?: Page
};



const route = useRoute()
const { id } = route.params
const { pages } = useContent()

const source = computed<Page>(() => {
  return (
    pages.value.find((i) => {
      return i.slug === id
    }) || new Page({})
  )
})

const computedMeta = computed(() => ({
  title: source.value?.title || '',
  meta: [
    { property: 'og:url', content: window.location.href },
    {
      vmid: 'og:description',
      property: 'og:description',
      content: renderRichText(source.value?.blocks?.[0]?.text).replace(/(<([^>]+)>)/gi, '') || '',
    },
    {
      vmid: 'description',
      property: 'description',
      content: renderRichText(source.value?.blocks?.[0]?.text).replace(/(<([^>]+)>)/gi, '') || '',
    },
  ],
}))

useMeta(computedMeta)

const titles = computed(() => source.value.blocks.map((i) => i.title))

const contentEl = ref<null | any>(null)
const block = ref<any[] | null>(null)
const moveTo = (index: number) => {
  contentEl.value?.$el.scrollToPoint(0, block.value?.[index].$el.offsetTop - 100, 300)
}

const activeTab = ref<null | number>(0)
const { width } = useWindowSize()
const isDesktop = computed(() => width.value > 768)
const aside = ref<HTMLElement | null>(null)
const scrollHandler = useDebounceFn(
  () => {
    if (!aside.value || !isDesktop.value) return
    const asideTop = aside.value.parentElement?.getBoundingClientRect().top
    aside.value.style.transform = `translateY(${Math.max(0, (asideTop || 0) * -1 + 40)}px)`
  },
  100,
  { maxWait: 100 }
)

onMounted(() => {
  // console.log('mounted', block.value)
})

return (_ctx: any,_cache: any) => {
  const _component_StoryblokComponent = _resolveComponent("StoryblokComponent")!
  const _component_IonContent = _resolveComponent("IonContent")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (_unref(source).content)
        ? (_openBlock(), _createBlock(_component_IonContent, {
            key: 0,
            ref_key: "contentEl",
            ref: contentEl,
            class: "page",
            "scroll-events": true,
            onIonScroll: _unref(scrollHandler)
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["wrapper", { 'is-mobile': !_unref(isDesktop) }])
                }, [
                  (_unref(isDesktop))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(titles).length > 1)
                          ? (_openBlock(), _createElementBlock("aside", {
                              key: 0,
                              ref_key: "aside",
                              ref: aside
                            }, [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(titles), (item, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    onClick: ($event: any) => (moveTo(i))
                                  }, _toDisplayString(item), 9, _hoisted_3))
                                }), 128))
                              ])
                            ], 512))
                          : _createCommentVNode("", true),
                        (_unref(source).blocks)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(source).blocks, (blok, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                  _createElementVNode("div", {
                                    class: "subtitle",
                                    onClick: ($event: any) => (moveTo(i))
                                  }, _toDisplayString(_unref(titles)[i]), 9, _hoisted_5),
                                  _createVNode(_component_StoryblokComponent, {
                                    ref_for: true,
                                    ref_key: "block",
                                    ref: block,
                                    blok: blok
                                  }, null, 8, ["blok"])
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(source).blocks, (blok, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "tab"
                        }, [
                          _createElementVNode("div", {
                            class: "title ion-padding-start ion-padding-end",
                            onClick: ($event: any) => (activeTab.value = activeTab.value === i ? null : i)
                          }, _toDisplayString(_unref(titles)[i]), 9, _hoisted_6),
                          _createVNode(ExpandTransition, {
                            value: activeTab.value === i
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_StoryblokComponent, {
                                ref_for: true,
                                ref_key: "block",
                                ref: block,
                                key: i,
                                class: "ion-padding",
                                blok: blok
                              }, null, 8, ["blok"]))
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        ]))
                      }), 128))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(source).title), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(source).title), 1)
              ])
            ]),
            _: 1
          }, 8, ["onIonScroll"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})